<template>
  <div class="ProjectInfo" v-loading="loading">
    <div style="width: 260px; height: calc(100vh - 70px)">
      <div
        style="
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          padding: 0 20px;
        "
      >
        <el-button
          style="
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
          "
          type="primary"
          @click="$router.go(-1)"
        >
          <span style="margin-left: 10px"
            ><i class="el-icon-back" style="margin-right: 10px"></i>
            后退前页</span
          ></el-button
        >
      </div>
      <el-menu
        :default-active="activeName"
        class="el-menu-vertical-demo"
        ref="menuTree"
        router
      >
        <el-menu-item :index="'/ProjectInfo/ProjectAll?id=' + this.$ProjectId">
          <i class="el-icon-monitor"></i>
          <span slot="title">工作台</span>
        </el-menu-item>
        <el-submenu
          v-for="item in MenuTteeData"
          :key="item.Id"
          :index="item.Id"
        >
          <template slot="title">
            <i
              :class="
                menuValue == 0
                  ? 'el-icon-office-building'
                  : 'icon-gongyingshang1 icon'
              "
            ></i>
            <span style="display: inline-block; white-space: normal">{{
              item.title
            }}</span>
          </template>
          <component
            v-for="ele in item.children"
            :key="ele.title"
            :index="ele.path || ele.Id"
            :is="ele.Type == 2 ? 'el-submenu' : 'el-menu-item'"
            popper-class="popper-menu"
          >
            <template slot="title">
              <i class="el-icon-edit-outline"></i>
              <span style="display: inline-block; white-space: normal">{{
                ele.title
              }}</span>
            </template>
            <template v-if="ele.children && ele.children.length > 0">
              <el-menu-item
                class="menu-item"
                v-for="v in ele.children"
                :key="v.Id"
                :index="v.path || v.Id"
              >
                <i class="el-icon-edit-outline"></i>
                <span
                  slot="title"
                  style="display: inline-block; white-space: normal"
                  >{{ v.title }}</span
                >
              </el-menu-item>
            </template>
          </component>
          <!-- <el-menu-item v-for="ele in item.children" :key="ele.Id" :index="ele.path">
            <i
              :class="
                ele.Type == 4 || ele.Type == 5
                  ? 'el-icon-edit-outline'
                  : 'el-icon-document'
              "
            ></i>
            {{ ele.title }}
          </el-menu-item> -->
        </el-submenu>
      </el-menu>
      <div class="tabsBut">
        <el-tabs type="border-card" v-model="menuValue" @tab-click="menuChange">
          <el-tab-pane label="设备审核" name="0"></el-tab-pane>
          <el-tab-pane label="资料审核" name="1"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div
      style="
        width: calc(100% - 260px);
        height: calc(100vh - 70px);
        overflow: hidden;
      "
    >
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: '',
      loading: false,
      ProjectInfo: {},
      MenuTteeData: [],
      domList: [
        {
          name: 'info',
          label: '项目信息',
          labelColor: '#409EFF',
          icon: 'el-icon-notebook-2',
          IconColor: '#409EFF',
          path: 'Info',
        },
        {
          name: 'ProjectClass',
          label: '项目设备分类',
          labelColor: '#C06BC1',
          icon: 'el-icon-s-grid',
          IconColor: '#C06BC1',
          path: 'ProjectClass',
        },
        {
          name: 'Facility',
          label: '资料模板',
          labelColor: '#C06BC1',
          icon: 'el-icon-s-grid',
          IconColor: '#C06BC1',
          path: 'Facility',
        },
        {
          name: 'TempSupplier',
          label: '项目供应商',
          IconColor: '#BFA170',
          icon: 'el-icon-s-management',
          labelColor: '#BFA170',
          path: 'TempSupplier',
        },
        {
          name: 'File',
          label: '项目云盘',

          icon: 'el-icon-folder',
          labelColor: '#70BABF',
          IconColor: '#70BABF',
          path: 'File',
        },
        // {
        //   name: 'ProjectStatistic',
        //   label: '统计信息',
        //   icon: 'el-icon-s-order',
        //   labelColor: '#67C23A',
        //   IconColor: '#67C23A',
        //   path: 'ProjectStatistic',
        // },
        {
          name: 'ProjectOverview',
          label: '项目统计总览',
          icon: 'el-icon-s-order',
          labelColor: '#67C23A',
          IconColor: '#67C23A',
          path: 'ProjectOverview',
        },
        // {
        //   name: "DeviceStatistic",
        //   label: "设备统计信息",

        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "DeviceStatistic",
        // },
        // {
        //   name: "SupplierStatistic",
        //   label: "供应商统计信息",
        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "SupplierStatistic",
        // },

        {
          name: 'BimModel',
          label: 'BIM模型',
          icon: 'el-icon-office-building',
          labelColor: '#DCDFE6',
          IconColor: '#DCDFE6',
          path: 'BimModel',
        },
        // {
        //   name: "Spare",
        //   label: "备件清单",

        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "Spare",
        // },
        // {
        //   name: "ScheduleDocument",
        //   label: "设备资料清单",
        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "ScheduleDocument",
        // },
        // {
        //   name: "Schedule",
        //   label: "设备审核",
        //   icon: "el-icon-edit-outline",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        //   path: "Schedule",
        // },
        // {
        //   name: "ProjectDocument",
        //   label: "项目资料审核",
        //   icon: "el-icon-edit-outline",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        //   path: "ProjectDocument",
        // },
        // {
        //   name: "TeamAuditDocument",
        //   label: "供应商审核",
        //   icon: "el-icon-edit-outline",
        //   path: "TeamAuditDocument",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        // },
        // {
        //   name: "ProjectInspect",
        //   label: "项目完结检查",
        //   icon: "el-icon-s-claim",
        //   labelColor: "#F56C6C",
        //   IconColor: "#F56C6C",
        //   path: "ProjectInspect",
        // },
      ],
      menuValue: '0',
      path: '',
    }
  },
  props: {},
  components: {},
  methods: {
    menuChange() {
      window.sessionStorage.setItem('menuValue', this.menuValue)
      if (this.$route.path == '/ProjectInfo/ProjectAll') {
        this.getMenuTtee(this.$route.query.id, this.menuValue)
      } else {
        this.$router.replace(
          '/ProjectInfo/ProjectAll?id=' + this.$route.query.id
        )
        this.getMenuTtee(this.$route.query.id, this.menuValue)
      }
    },
    getProjectInfo() {
      this.$http
        .post(
          '/Base_Manage/Home/GetProjectInfo?ProjectId=' + this.$ProjectId,
          {}
        )
        .then((res) => {
          if (res.Success) {
            this.ProjectInfo = res.Data
            window.localStorage.setItem('ProjectInfo', JSON.stringify(res.Data))
            window.localStorage.setItem('ProjectName', res.Data.Name)
          }
        })
    },
    async getMenuTtee(id, Type) {
      this.loading = true
      await this.$http
        .post(
          `/PB/PB_Project/GetProjectDeviceTypeTree?ProjectId=${id}&Type=${
            Type || this.menuValue
          }`,
          {}
        )
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            let Data = res.Data.filter((item) => {
              return item.Type == 2 || item.Type == 5
            })

            Data.forEach((item) => {
              item.children?.forEach((ele) => {
                const baseParams = `id=${this.$route.query.id}&BuildingId=${
                  ele.BuildingId || ''
                }&BuildingFloor=${ele.BuildingFloor || ''}&devId=${
                  ele.Id || ''
                }&InstallationArea=${ele.InstallationArea || ''}&ParentId=${
                  ele.ParentId || ''
                }&SupplyType=${ele.SupplyType || ''}`
                // if (ele.Type == 4) {
                //   ele.children?.forEach((v) => {
                //     v.path = `/ProjectInfo/ProjectDeviceAudit?id=${this.$route.query.id}&BuildingId=${v.BuildingId}&BuildingFloor=${v.BuildingFloor}&devId=${v.Id}&InstallationArea=${v.InstallationArea}`
                //   })
                // } else
                if (ele.Type == 3) {
                  ele.path = `/ProjectInfo/ProjectDeviceAudit?${baseParams}`
                } else if (ele.Type === 4) {
                  //供应商资质审核
                  ele.path = `/ProjectInfo/TeamAuditDocument?${baseParams}`
                } else if (ele.Type === 5) {
                  //项目资料审核
                  ele.path = `/ProjectInfo/ProjectDocument?${baseParams}`
                } else if (ele.Type === 6) {
                  //备件审核
                  ele.path = `/ProjectInfo/SparesReview?${baseParams}`
                } else if (ele.Type === 7) {
                  //统计
                  ele.path = `/ProjectInfo/SupplierStatistics?${baseParams}`
                }

                // const baseParams = `id=${this.$route.query.id}&devId=${item.Id}&ParentId=${item.ParentId}`;
                // if (item.Type === 3) {
                //   item.path = `/ProjectInfo/ProjectDeviceAudit?${baseParams}`;
                // } else if (item.Type === 4) {
                //   item.path = `/ProjectInfo/TeamAuditDocument?${baseParams}`;
                // } else if (item.Type === 5) {
                //   item.path = `/ProjectInfo/ProjectDocument?${baseParams}`;
                // }
              })
            })
            this.MenuTteeData = [...Data]

            // // this.ProjectInfo = res.Data;
            // let n = this.$route;
            // let index = this.whiteList.findIndex((item) => {
            //   return n.path.indexOf(item) > -1;
            // });
            // if (index > -1) {
            //   // this.activeName = "/ProjectInfo/ProjectAll";
            //   this.activeName = this.whiteList[index];
            // } else {
            //   await this.$nextTick(() => {
            //     if (window.localStorage.getItem("itemType")) {
            //       let item = JSON.parse(window.localStorage.getItem("itemType"));
            //       this.$refs.menuTree.open(
            //         JSON.stringify({
            //           Id: item.prId,
            //           Type: 2,
            //           prId: item.prId,
            //         })
            //       );
            //       setTimeout(() => {
            //         this.activeName = window.localStorage.getItem("itemType");
            //       }, 1);
            //     }
            //     console.log(this.activeName, "this.activeName this.activeName ");
            //   });
            //   // this.activeName = n.path;
            // }
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
  },
  mounted() {},
  async created() {
    // await this.getProjectInfo(this.$route.query.id);
    if (window.sessionStorage.getItem('menuValue')) {
      this.menuValue = window.sessionStorage.getItem('menuValue')
    }
    this.getMenuTtee(this.$ProjectId, this.menuValue)
    console.log('222222222222222222222222')
  },
  computed: {
    activeName() {
      const { path, query } = this.$route
      console.log(path, 'path')

      let obj = this.domList.find((item) => {
        return path.indexOf('/ProjectInfo/' + item.path) > -1
      })
      if (obj) {
        return '/ProjectInfo/ProjectAll?id=' + this.$route.query.id
      }
      if (path.indexOf('/ProjectInfo/ProjectAll') > -1) {
        return '/ProjectInfo/ProjectAll?id=' + this.$route.query.id
      }
      // 按固定顺序拼接参数
      const params = []
      params.push(`id=${query.id || ''}`)
      params.push(`BuildingId=${query.BuildingId || ''}`)
      params.push(`BuildingFloor=${query.BuildingFloor || ''}`)
      params.push(`devId=${query.devId || ''}`)

      params.push(`InstallationArea=${query.InstallationArea || ''}`)
      params.push(`ParentId=${query.ParentId || ''}`)
      params.push(`SupplyType=${query.SupplyType || ''}`)
      return params.length ? `${path}?${params.join('&')}` : path
    },
  },
  updated() {},
  watch: {
    $route: {
      handler(n, o) {},
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.ProjectInfo {
  width: 100%;
  display: flex;
  height: 100%;
  background: #fff;
}
.el-menu-vertical-demo {
  height: calc(100% - 50px);
  overflow-y: auto;
  overflow-x: hidden;
}
.el-menu-vertical-demo {
  height: calc(100% - 90px);
  overflow-y: auto;
  overflow-x: hidden;
}
::v-deep .el-menu-item,
.el-submenu__title {
  line-height: 1.2;
  display: flex;
  align-items: center;
}
::v-deep .el-submenu__title {
  line-height: 1.2 !important;
  display: flex;
  align-items: center;
}
.el-menu-item,
.el-submenu__title ::v-deep .el-submenu__title {
  display: flex;
  align-items: center;
}
::v-deep .el-menu-item {
  display: flex;
  align-items: center;
}
.tabsBut {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-radio-button__inner {
  width: 100%;
}
::v-deep .tabsBut {
  .el-tabs__content {
    display: none;
  }
  .el-tabs--border-card {
    width: 100%;
    box-shadow: none;
    .el-tabs__header {
      width: 100%;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .el-tabs__item {
    width: 50%;
    padding: 0 !important;
    text-align: center;
  }
}
</style>
